import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
  NbSearchService,
  NbToastrService,
} from "@nebular/theme";

import { UserData } from "../../../@core/data/users";
import { LayoutService } from "../../../@core/utils";
import { map, takeUntil, filter } from "rxjs/operators";
import { Subject } from "rxjs";
import { NotificationsService } from "../../../service/notifications.service";
import { Router } from "@angular/router";
import { AuthService } from "../../../service/auth.service";
import { duration } from "moment";

@Component({
  selector: "ngx-header",
  styleUrls: ["./header.component.scss"],
  templateUrl: "./header.component.html",
})
export class HeaderComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  userName: string;
  userMenu = [{ title: "User" }, { title: "Log out" }];

  // This is to show facebook like notifications.
  // notifications = [
  //   { title: 'Some Info' },
  //   { title: 'Some Other Info' },
  // ];

  notificationsLength: string;

  themes = [
    {
      value: "default",
      name: "Light",
    },
    {
      value: "dark",
      name: "Dark",
    },
    {
      value: "cosmic",
      name: "Cosmic",
    },
    {
      value: "corporate",
      name: "Corporate",
    },
  ];

  currentTheme = "default";

  constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private notificationService: NotificationsService,
    private router: Router,
    private authService: AuthService,
    private toastrService: NbToastrService,
    private searchService: NbSearchService
  ) {}

  ngOnInit() {
    this.userName = localStorage.getItem("userName") || "@Admin";
    this.userMenu = [{ title: this.userName }, { title: "Log out" }];
    this.notificationService.fetchNotifications().subscribe((res) => {
      let data = res;
      if (data.length > 0)
        if (data[1]["MarkedNotifications"] == undefined) {
          this.notificationsLength = data[0]["Notifications"].length.toString();
        } else {
          if (
            data[0]["Notifications"].length - res[1]["MarkedNotifications"] ==
            0
          ) {
            this.notificationsLength = "";
          } else {
            this.notificationsLength = (
              data[0]["Notifications"].length - res[1]["MarkedNotifications"]
            ).toString();
            this.showToast("1200", "top-right", "success");
          }
        }
    });

    this.currentTheme = this.themeService.currentTheme;

    this.userService
      .getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => (this.user = users.nick));

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl)
      );

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$)
      )
      .subscribe((themeName) => (this.currentTheme = themeName));

    this.menuService
      .onItemClick()
      .pipe(
        filter(({ tag }) => tag === "my-context-menu"),
        map(({ item: { title } }) => title)
      )
      .subscribe((title) => {
        if (title === "Log out") {
          this.authService.signOut();
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, "menu-sidebar");
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  onNotificationClick() {
    this.router.navigate(["pages/notifications"]);
  }

  showToast(duration, position, status) {
    this.toastrService.show(
      "",
      `Received ${this.notificationsLength} New Notification`,
      { duration, position, status }
    );
  }
}
